const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/**
 * Escape text for interpolation into an HTML string (innerHTML, Google Maps
 * InfoWindow content, attribute values). Use for translated copy and data —
 * never for markup that is meant to render.
 */
export const escapeHtml = (value: string | number | null | undefined): string =>
  String(value ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPES[char] ?? char);
